export default {
    getDateOutDateTime(dateTime, delimiter = '.') {
        return this.zero(dateTime.getDate()) + delimiter + this.zero(dateTime.getMonth() + 1) + delimiter + dateTime.getFullYear()
    },
    getDateOutDateTimeForPicker(dateTime, delimiter = '.') {
        return dateTime.getFullYear() + delimiter + this.zero((dateTime.getMonth() + 1)) + delimiter + this.zero(dateTime.getDate())
    },
    getTimeOutDateTime(dateTime, delimiter = ':') {
        return this.zero(dateTime.getHours()) + delimiter + this.zero(dateTime.getMinutes())
    },
    getDateOutUnixTime(unixTime, delimiter = '.') {
        let dateTime = new Date(unixTime * 1000)
        return this.getDateOutDateTime(dateTime, delimiter)
    },
    getTimeOutUnixTime(unixTime, delimiter = ':') {
        let dateTime = new Date(unixTime * 1000)
        return this.getTimeOutDateTime(dateTime, delimiter)
    },
    getDateFormatOutDate(dateTime, format = 'YYYY.MM.DD HH:mm') {
        format = format.replace(/DD/g, this.zero(dateTime.getDate()))
        format = format.replace('MM', this.zero(dateTime.getMonth() + 1))
        format = format.replace('YYYY', dateTime.getFullYear() + '')
        format = format.replace('HH', this.zero(dateTime.getHours()))
        format = format.replace('mm', this.zero(dateTime.getMinutes()))
        return format
    },
    zero(number) {
        if (number < 10) {
            number = '0' + number
        }
        return number
    },
    addDays(dateTime = new Date(), days = 0) {
        dateTime.setDate(dateTime.getDate() + days)
        return dateTime
    },
    addHours(dateTime = new Date(), hours = 0) {
        dateTime.setHours(dateTime.getHours() + hours)
        return dateTime
    },
    getUnixTimeByDate(date = new Date()) {
        return Date.parse(date.replace(/-/g, '/')) / 1000
    },
    scheduleGetIntervalsByStr(str) { // 12-14, превращает в массив [12:00][14:00]
        if (str.indexOf('-') !== -1) {
            return this.scheduleGetIntervalByValue(str.split('-'))
        } else {
            return this.scheduleGetIntervalByValue([str, str + 1])
        }
    },
    scheduleGetIntervalByValue(value) {
        return [this.scheduleGetTimeByStr(value[0]), this.scheduleGetTimeByStr(value[1])]
    },
    scheduleGetTimeByStr(str) {
        if ((String(str)).indexOf(':') !== -1) {
            return str
        } else {
            return str + ':00'
        }
    },
    scheduleGetStrByInterval(array) {

    },
    scheduleGetHourStr(hour) { // 12:00 -> 12

    }
}
